const comments = [
  {
    id: 1,
    name: '追剧小达人',
    avatar: 'R',
    rating: 5,
    date: '3天前',
    content: '棒棒TV真的太香了！不用注册就能看，画质清晰不卡顿，《星河长明》都追到最新一集了，推荐给所有喜欢追剧的朋友。',
  },
  {
    id: 2,
    name: '电影控阿杰',
    avatar: 'J',
    rating: 5,
    date: '1周前',
    content: '电影资源更新的速度真的快，院线刚下线的大片这里就有了。播放流畅，没有任何广告干扰，观影体验满分。',
  },
  {
    id: 3,
    name: '韩剧迷妹',
    avatar: 'M',
    rating: 4,
    date: '2周前',
    content: '韩剧专区太全了！最新的韩剧基本都有，字幕也做得很好。唯一希望就是能加一个收藏功能，方便追更。',
  },
  {
    id: 4,
    name: '动漫爱好者',
    avatar: 'A',
    rating: 5,
    date: '3周前',
    content: '国产动漫的资源很全，《星际纪元》全季一次性看完太过瘾了。画质支持1080P，在大屏幕上看起来体验超棒。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            用户评价
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            来自真实用户的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-600">
                    {comment.avatar}
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-900">
                    {comment.name}
                  </p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < comment.rating
                        ? 'ri-star-fill text-accent-400'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}